//引入Vue
import Vue from 'vue';
//引入vuex
import vuex from 'vuex';
//安装插件
Vue.use(vuex);
//引入小仓库
import home from './modules/home';
//创建仓库
export default new vuex.Store({
    modules: {
        home,
    },
    strict:true
})



